module.exports = __webpack_public_path__ + "img/9788985635950.f0e0716a.jpg";